export default __webpack_public_path__ + "static/start-for-free-fab42f47059820b44b2a122bf7d2cbac.mp4";